import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";

export const DiscardFormModal = ({ onClose, onConfirm }) => {
  return (
    <Dialog
      open
      title="Discard form?"
      onClose={onClose}
      width={480}
    >
      <p
        style={{
          fontSize: "16px",
          lineHeight: "24px",
          color: "var(--gray-950)",
        }}
      >
        If you exit now, all data entered in this form will be lost and cannot
        be recovered. Are you sure you want to discard your progress?
      </p>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>
          Discard
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
